import { useMemo, useState } from 'react';

import { SORT_LABELS, SORT_VALUES } from 'constants/sort';

const useOffersSort = (sortValue) => {
  const [offersSort, setOffersSort] = useState(sortValue || SORT_VALUES.LATEST);

  const options = useMemo(
    () => [
      {
        label: SORT_LABELS.BY_LATEST,
        value: SORT_VALUES.LATEST,
        isSelected: offersSort === SORT_VALUES.LATEST,
      },
      {
        label: SORT_LABELS.BY_MOST_LIKED,
        value: SORT_VALUES.MOST_REACTED,
        isSelected: offersSort === SORT_VALUES.MOST_REACTED,
      },
      {
        label: SORT_LABELS.BY_MOST_COMMENTED,
        value: SORT_VALUES.MOST_COMMENTED,
        isSelected: offersSort === SORT_VALUES.MOST_COMMENTED,
      },
    ],
    [offersSort]
  );

  return { options, offersSort, setOffersSort };
};

export default useOffersSort;
